/**
 * en-GB messages added by Phase 4 task K8 (docs/PHASE-4-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const k8EnGB = {
    // Language picker
    'kiosk.language.label': 'Language',
    // Read-only account (HTTP 423 tenant_read_only)
    'kiosk.readOnly.title': 'Sign-in is paused',
    'kiosk.readOnly.message': 'Sign-in is paused for this organisation. Please see reception.',
    // Drill, and ending an evacuation
    'kiosk.welcome.drill': 'Start drill',
    'kiosk.evacuation.drillStartTitle': 'Start a drill',
    'kiosk.evacuation.drillConfirmTitle': 'Start a drill?',
    'kiosk.evacuation.drillConfirmMessage': 'This opens the roll call as a practice. Everyone on site is alerted.',
    'kiosk.evacuation.drillConfirmStart': 'Start drill',
    'kiosk.evacuation.drillOffline': 'A drill can only be started when this kiosk is online.',
    'kiosk.evacuation.end': 'End evacuation',
    'kiosk.evacuation.endDrill': 'End drill',
    'kiosk.evacuation.endTitle': 'Enter the PIN to end the evacuation',
    'kiosk.evacuation.endDrillTitle': 'Enter the PIN to end the drill',
    'kiosk.evacuation.endConfirm': 'This closes the roll call on every screen and saves the report. Only end it when everyone is accounted for.',
    'kiosk.evacuation.endNow': 'End now',
    'kiosk.evacuation.endOffline': 'This kiosk is offline. An evacuation can only be ended when it is online.',
    'kiosk.evacuation.endFailed': 'The evacuation could not be ended. Please try again.',
    // ID check step
    'kiosk.idCheck.title': 'ID check',
    'kiosk.idCheck.pickHint': 'Please show one of these. It is read on this screen and the picture is not kept.',
    'kiosk.idCheck.passport': 'Passport',
    'kiosk.idCheck.drivingLicence': 'Driving licence',
    'kiosk.idCheck.nationalId': 'ID card',
    'kiosk.idCheck.guide': 'Hold the document inside the frame, flat and well lit.',
    'kiosk.idCheck.take': 'Take picture',
    'kiosk.idCheck.switchCamera': 'Switch camera',
    'kiosk.idCheck.typeInstead': 'Type the details instead',
    'kiosk.idCheck.typeOnly': 'This kiosk cannot read documents with the camera, so the details are typed in.',
    'kiosk.idCheck.privacy': 'The picture is read on this tablet and deleted straight away.',
    'kiosk.idCheck.noCamera': 'The camera is not available.',
    'kiosk.idCheck.reading': 'Reading…',
    'kiosk.idCheck.unreadable': 'We could not read the document. Please try again, or type the details instead.',
    'kiosk.idCheck.readFailed': 'Something went wrong with the camera. Please try again, or type the details instead.',
    'kiosk.idCheck.manualTitle': 'Type the document details',
    'kiosk.idCheck.manualHint': 'Copy the name and the expiry date exactly as printed on the document.',
    'kiosk.idCheck.manualInvalid': 'Please enter both names and a real expiry date.',
    'kiosk.idCheck.surname': 'Surname',
    'kiosk.idCheck.givenNames': 'First and middle names',
    'kiosk.idCheck.expiry': 'Expiry date',
    'kiosk.idCheck.day': 'Day',
    'kiosk.idCheck.month': 'Month',
    'kiosk.idCheck.year': 'Year',
    'kiosk.idCheck.skip': 'Skip the ID check',
    'kiosk.idCheck.byEye': 'Reception will check by eye',
    'kiosk.idCheck.skipPinTitle': 'Reception: enter the site PIN',
    'kiosk.idCheck.requiredNoSkip': 'An ID check is needed here. Please see reception if you cannot do it.',
    'kiosk.idCheck.passTitle': 'Thank you',
    'kiosk.idCheck.passMessage': 'Your ID has been checked.',
    'kiosk.idCheck.warnTitle': 'Reception will take a look',
    'kiosk.idCheck.warnMessage': 'We could not match your ID. You can carry on, and reception has been told.',
    'kiosk.idCheck.refuseTitle': 'Please see reception',
    'kiosk.idCheck.refuseMessage': 'We could not match your ID, so you cannot sign in here.',
    'kiosk.idCheck.refusedMessage': 'We could not match your ID. Please see reception to sign in.',
};
//# sourceMappingURL=k8.js.map